<template>
  <footer class="py-4" style="background-color: rgb(37 37 37)">
    <div class="container mx-auto px-4">
      <p class="text-sm text-center text-white" >© 2026 QREventos.com</p>
    </div>
  </footer>
</template>


<script>
import VueScrollTo from 'vue-scrollto';

export default {
  name: 'FooterSection',
  methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
  },
}

</script>